import authGraphQLRequest from "utils/authGraphQLRequest";
import authRequest from "../utils/authRequest";
import moment from "moment";
 

export const getCustomers = ({ page, per_page, searchTexts,filter }: any): Promise<any> => {
  return new Promise((resolve, reject) => {

    const clients =
      filter?.clients?.length > 0
        ? `[${filter.clients.map((c: string) => `"${c}"`).join(",")}]`
        : "";

    const gateways =
      filter?.gateways?.length > 0
        ? `[${filter.gateways.map((g: string) => `"${g}"`).join(",")}]`
        : "";

    const start_date = filter?.dates?.[0]
        ? moment(filter.dates[0]).format("YYYY-MM-DD")
        : "";

    const end_date = filter?.dates?.[1]
        ? moment(filter.dates[1]).format("YYYY-MM-DD")
        : "";

    let queryString = `{ 
      allCustomers(
        page: ${page}, 
        per_page: ${per_page}, 
        searchTexts: "${searchTexts}"
        ${clients ? `, clients: ${clients}` : ""}
        ${gateways ? `, gateways: ${gateways}` : ""}
        ${start_date ? `, start_date: "${moment(start_date).format("YYYY-MM-DD")}"` : ""}
        ${end_date ? `, end_date: "${moment(end_date).format("YYYY-MM-DD")}"` : ""}
      ) {
        customer{
            customer_id   
            client_id     
            first_name
            last_name
            middle_name
            email
            phone
            city
            address
            state
            country
            birthDate
            reference_id
            source_client
            created_at
            updated_at
            total_transactions
            transactionsList
            paymentMethods
            kyc
        }
      }
    }`;

    authGraphQLRequest<any>(
      queryString,
      '/api/v1/graphql_customer_list'
    )
      .then((responseData) => {
        resolve(responseData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const checkLinkData = (link_id:any): Promise<any> => {

  const authRequired = false 

  return new Promise((resolve, reject) => {
    authRequest({
      url: "/api/v1/customer/link/details/"+link_id,
      method: "get",
      authRequired
    })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const checkKycDocument = (kyc_id:any): Promise<any> => {

  const authRequired = false 

  return new Promise((resolve, reject) => {
    authRequest({
      url: "/api/v1/customer/view-kyc/"+kyc_id,
      method: "get",
      authRequired
    })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const markLinkExpired = (link_id:any): Promise<any> => {

  const authRequired = false 

  return new Promise((resolve, reject) => {
    authRequest({
      url: "/api/v1/customer/link/expired/"+link_id,
      method: "get",
      authRequired
    })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const createCustomer = (data : any): Promise<any> => {
  return new Promise((resolve, reject) => {
    let queryString = `mutation {
      createCustomerFront(
        clientId: "${data.client_id}"
        general: {
          firstName: "${data.general.first_name}"
          middleName: "${data.general.middle_name}"
          lastName: "${data.general.last_name}"
          email: "${data.general.email}"
          phone: "${data.general.phone}"
          city: "${data.general.city}"
          address: "${data.general.address}"
          postalCode: "${data.general.postal_code}"
          state: "${data.general.state}"
          country: "${data.general.country}"
          ip: "0.0.0.0"
          birthDate: "${data.general.birth_date}"
        }
        kyc: {
          identificationNumber1: "${data.kyc.identification_number_1}"
          identificationType1: "${data.kyc.identification_type_1}"
          identificationIssuedAt1: "${data.kyc.identification_issued_at_1}"
          identificationExpiredAt1: "${data.kyc.identification_expired_at_1}"
          identificationNumber2: "${data.kyc.identification_number_2}"
          identificationType2: "${data.kyc.identification_type_2}"
          identificationIssuedAt2: "${data.kyc.identification_issued_at_2}"
          identificationExpiredAt2: "${data.kyc.identification_expired_at_2}"
          identificationNumber3: "${data.kyc.identification_number_3}"
          identificationType3: "${data.kyc.identification_type_3}"
          identificationIssuedAt3: "${data.kyc.identification_issued_at_3}"
          identificationExpiredAt3: "${data.kyc.identification_expired_at_3}"
          identificationNumber4: "${data.kyc.identification_number_4}"
          identificationType4: "${data.kyc.identification_type_4}"
          identificationIssuedAt4: "${data.kyc.identification_issued_at_4}"
          identificationExpiredAt4: "${data.kyc.identification_expired_at_4}"
          identificationNumber5: "${data.kyc.identification_number_5}"
          identificationType5: "${data.kyc.identification_type_5}"
          identificationIssuedAt5: "${data.kyc.identification_issued_at_5}"
          identificationExpiredAt5: "${data.kyc.identification_expired_at_5}"
        }
        paymentMethod: {
          type: "${data.payment_method.type}"
          card: {
            cardholderName: "${data.payment_method.card.cardholder_name}"
            cardNumber: "${data.payment_method.card.card_number}"
            expirationMonth: "${data.payment_method.card.expiration_month}"
            expirationYear: "${data.payment_method.card.expiration_year}"
            cvv: "${data.payment_method.card.cvv}"
          }
          bank: {
            iban: "${data.payment_method.bank.iban}"
            swiftNo: "${data.payment_method.bank.swift_no}"
            bankId: "${data.payment_method.bank.bank_id}"
            accountNumber: "${data.payment_method.bank.account_number}"
            accountType: "${data.payment_method.bank.account_type}"
            bankName: "${data.payment_method.bank.bank_name}"
            bankBranch: "${data.payment_method.bank.bank_branch}"
          }
          crypto: {
            walletAddress: "${data.payment_method.crypto.wallet_address}"
          }
        }
      ) {
        status
        customer
        message
      }
    }
`;

    authGraphQLRequest<any>(
      queryString,
      '/api/v1/graphql_create_customer_front'
    )
      .then((responseData) => {
        resolve(responseData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const customerRegistrationForm = (data: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        const kycArray = (data.kyc || [])
            .map((item: any) => {
                return `{
                    identificationNumber: "${item.identification_number || ""}"
                    identificationType: "${item.identification_type || ""}"
                    identificationIssuedAt: "${item.identification_issued_at || ""}"
                    identificationExpiredAt: "${item.identification_expired_at || ""}"
                    documentFile: "${item.document_file || ""}"
                }`;
            })
            .join(",");
        const cardArray = (data.payment_method.card || [])
            .map((card: any) => {
                return `{
                    cardholderName: "${card.cardholder_name}"
                    cardNumber: "${card.card_number}"
                    expirationMonth: "${card.expiration_month}"
                    expirationYear: "${card.expiration_year}"
                    cvv: "${card.cvv}"
                }`;
            })
            .join(",");
        const bankArray = (data.payment_method.bank || [])
            .map((bank: any) => {
                return `{
                    iban: "${bank.iban}"
                    swiftNo: "${bank.swift_no}"
                    bankId: "${bank.bank_id}"
                    accountNumber: "${bank.account_number}"
                    accountType: "${bank.account_type}"
                    bankName: "${bank.bank_name}"
                    bankBranch: "${bank.bank_branch}"
                }`;
            })
            .join(",");
        const cryptoArray = (data.payment_method.crypto || [])
            .map((c: any) => {
                return `{
                    walletAddress: "${c.wallet_address}"
                }`;
            })
            .join(",");
        const queryString = `
            mutation {
                customerRegistration(
                    clientId: "${data.client_id}"
                    linkId: "${data.link_id}"
                    general: {
                        firstName: "${data.general.first_name}"
                        middleName: "${data.general.middle_name}"
                        lastName: "${data.general.last_name}"
                        email: "${data.general.email}"
                        phone: "${data.general.phone}"
                        city: "${data.general.city}"
                        address: "${data.general.address}"
                        postalCode: "${data.general.postal_code}"
                        state: "${data.general.state}"
                        country: "${data.general.country}"
                        ip: "${data.general.ip}"
                        birthDate: "${data.general.birth_date}"
                        referenceId: "${data.general.reference_id}"
                        callbackUrl: "${data.general.callback_url}"
                        returnUrl: "${data.general.return_url}"
                    }
                    kyc: [${kycArray}]
                    paymentMethod: {
                        type: "${data.payment_method.type}"
                        card: [${cardArray}]
                        bank: [${bankArray}]
                        crypto: [${cryptoArray}]
                    }
                ) {
                    status
                    message
                    customer
                }
            }
        `;
        authGraphQLRequest<any>(
            queryString,
            '/api/v1/graphql_customer_registration'
        )
        .then((responseData) => resolve(responseData))
        .catch((err) => reject(err));
    });
};

export const customerRegistrationFormFront = (data: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        const kycArray = (data.kyc || [])
            .map((item: any) => {
                return `{
                    identificationNumber: "${item.identification_number || ""}"
                    identificationType: "${item.identification_type || ""}"
                    identificationIssuedAt: "${item.identification_issued_at || ""}"
                    identificationExpiredAt: "${item.identification_expired_at || ""}"
                    documentFile: "${item.document_file || ""}"
                }`;
            })
            .join(",");
        const cardArray = (data.payment_method.card || [])
            .map((card: any) => {
                return `{
                    cardholderName: "${card.cardholder_name}"
                    cardNumber: "${card.card_number}"
                    expirationMonth: "${card.expiration_month}"
                    expirationYear: "${card.expiration_year}"
                    cvv: "${card.cvv}"
                }`;
            })
            .join(",");
        const bankArray = (data.payment_method.bank || [])
            .map((bank: any) => {
                return `{
                    iban: "${bank.iban}"
                    swiftNo: "${bank.swift_no}"
                    bankId: "${bank.bank_id}"
                    accountNumber: "${bank.account_number}"
                    accountType: "${bank.account_type}"
                    bankName: "${bank.bank_name}"
                    bankBranch: "${bank.bank_branch}"
                }`;
            })
            .join(",");
        const cryptoArray = (data.payment_method.crypto || [])
            .map((c: any) => {
                return `{
                    walletAddress: "${c.wallet_address}"
                }`;
            })
            .join(",");
        const queryString = `
            mutation {
                customerRegistrationFront(
                    clientId: "${data.client_id}"
                    general: {
                        firstName: "${data.general.first_name}"
                        middleName: "${data.general.middle_name}"
                        lastName: "${data.general.last_name}"
                        email: "${data.general.email}"
                        phone: "${data.general.phone}"
                        city: "${data.general.city}"
                        address: "${data.general.address}"
                        postalCode: "${data.general.postal_code}"
                        state: "${data.general.state}"
                        country: "${data.general.country}"
                        ip: "${data.general.ip}"
                        birthDate: "${data.general.birth_date}"
                        referenceId: "${data.general.reference_id}"
                        callbackUrl: "${data.general.callback_url}"
                        returnUrl: "${data.general.return_url}"
                    }
                    kyc: [${kycArray}]
                    paymentMethod: {
                        type: "${data.payment_method.type}"
                        card: [${cardArray}]
                        bank: [${bankArray}]
                        crypto: [${cryptoArray}]
                    }
                ) {
                    status
                    message
                    customer
                }
            }
        `;
        authGraphQLRequest<any>(
            queryString,
            '/api/v1/graphql_customer_registration_front'
        )
        .then((responseData) => resolve(responseData))
        .catch((err) => reject(err));
    });
};

export const uploadKycDocument = ({ customer_id,kyc_id,document }: any): Promise<any> => {
  return new Promise((resolve, reject) => {
    let queryString = `mutation {
    uploadKycDocument(
        customer_id : "${customer_id}",
        kyc_id : "${kyc_id}",
        document : "${document}"
    ) {
        status
        message
    }
}
`;

    authGraphQLRequest<any>(
      queryString,
      '/api/v1/graphql_upload_kyc_document'
    )
      .then((responseData) => {
        resolve(responseData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};